import React, { useMemo, useCallback, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { AgGridReact } from '@ag-grid-community/react';
import { Accordion, Icon } from 'semantic-ui-react';
import { GRID_OPTIONS } from '../../../../../HelperMethods/AgGridConstants';
import AgGridContainer from '../../../../common/AgGridContainer';
import styles from './ManifestFormAuditLog.module.css';

function getActionName(log) {
  if (log.entity === 'signature') {
    return 'Updated Signature';
  }
  if (log.entity === 'form') {
    return _.isEmpty(log.before) ? 'Created Form' : 'Updated Form';
  }
  return null;
}

function getUserName(log) {
  if (log.entity === 'signature') {
    return log.signatureObject.modifiedBy;
  }
  if (log.entity === 'form') {
    return log.after.modifiedBy;
  }
  return null;
}

const columnDefs = [
  { header: 'Date', field: 'date' },
  { header: 'Time', field: 'time' },
  { header: 'User Name', field: 'username' },
  { header: 'Action', field: 'action' },
];

export default function ManifestFormAuditLog({ data }) {
  const rowData = useMemo(() => {
    if (!data) return data;
    let username = '';
    const clonedData = [...data];
    return clonedData
      .sort((l1, l2) => new Date(l1.createdOn).getTime() - new Date(l2.createdOn).getTime())
      .map((log) => {
        username = getUserName(log) || username;
        return {
          date: moment(log.createdOn).format('D-MMM-YYYY'),
          time: moment(log.createdOn).format('hh:mm A'),
          action: getActionName(log),
          username,
        };
      });
  }, [data]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const handleClick = useCallback(
    (e, titleProps) => {
      const { index } = titleProps;
      const newIndex = activeIndex === index ? -1 : index;
      setActiveIndex(newIndex);
    },
    [activeIndex, setActiveIndex]
  );
  if (!rowData) return null;
  return (
    <Accordion fluid>
      <Accordion.Title active={activeIndex === 0} index={0} onClick={handleClick} style={{ paddingBottom: '0px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '17px 23px',
            background: '#eefbfa',
            fontSize: '14px',
            fontFamily: 'JoynFontMedium',
          }}
        >
          <div>Form Audit Trail</div>
          <div>
            <Icon
              style={{ marginTop: '-6px', marginRight: '0px', fontSize: '23px' }}
              name={`angle ${activeIndex === 0 ? 'up' : 'down'}`}
            />
          </div>
        </div>
      </Accordion.Title>
      <Accordion.Content active={activeIndex === 0} style={{ paddingTop: '0px' }}>
        <AgGridContainer className={styles.manifestFormAuditGrid} numberOfRow={(rowData && rowData.length) || 0}>
          <div
            className="ag-theme-balham"
            style={{
              height: '100%',
              width: '100%',
            }}
          >
            <AgGridReact
              {...GRID_OPTIONS}
              columnDefs={columnDefs}
              rowData={rowData}
              onRowDataChanged={(params) => {
                params.api.sizeColumnsToFit();
              }}
              icons={{
                menu: '<i class="fa fa-filter"></i>',
              }}
            />
          </div>
        </AgGridContainer>
      </Accordion.Content>
    </Accordion>
  );
}

ManifestFormAuditLog.propTypes = {
  data: PropTypes.array,
};
